import * as React from 'react';
import Reddit from './components/Reddit';

export default function App() {
  return (
    <div>
      <Reddit />
    </div>
  );
}
